var focusableElementSelectors = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[tabindex]:not([tabindex^="-"]):not([disabled])', '*[contenteditable]'];
var focusableElementSelector = focusableElementSelectors.join(',');
var queryFocusableElements = function queryFocusableElements(container) {
  return container.querySelectorAll(focusableElementSelector);
};

export { queryFocusableElements };
